import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css';

const DEFAULT_ROW = 41
class PrintReportColorDetail extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.year!=undefined&&this.props.month!=undefined&&this.props.productcode!=undefined) {
            ReportStore.loadUsageVolumeDetail(this.props.year,this.props.month,this.props.productcode,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getDetailSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length==0) {
          return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
                <td className='text-center'>{(indexs*40)+index+1}</td>
                <td className='text-center'>{item.car_registration_no}</td>
                <td className='text-center'>{item.productcode}</td>
                <td className='text-center'>{item.description}</td>                        
                <td className='text-center'>{this.getNumberFormat(item.usage_quantity)}</td>
                <td className='text-center'>{item.technician}</td>
                <td className='text-right'>{item.remark}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        return(
            <table className='table table-print-report-material'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'120px'}}>เลขทะเบียน</td>
                        <td className='text-center' style={{width:'100px'}}>รหัสสินค้า</td>
                        <td className='text-center' style={{width:'200px'}}>คำอธิบาย</td>
                        <td className='text-center' style={{width:'100px'}}>ปริมาณการใช้ (กรัม)</td>
                        <td className='text-center' style={{width:'100px'}}>ช่าง</td>
                        <td className='text-center' style={{width:'200px'}}>หมายเหตุ</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {length-1===index?
                    <tr>
                        <td colSpan={4} className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-center'>{this.getNumberFormat(this.getDetailSummary('usage_quantity'))}</td>
                        <td className='text-right'></td>
                        <td className='text-right'></td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        let {description,productcode} = this.props
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                {description!=''?<div>คำอธิบาย: {description} รหัสสินค้า: {productcode}</div>:''}
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportColorDetail.defaultProps = {
    title: 'ตารางรายงานการใช้สีประจำเดือน',  
    mode : '',
    workNo : ''
  }
  export default PrintReportColorDetail;


// WEBPACK FOOTER //
// ./src/view/print/material/PrintReportColorDetail.js